import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationDrawerStore = defineStore(
  'navigation-drawer',
  () => {
    const isOpen = ref(true);
    const width = 256;

    return { isOpen, width };
  },
  { persist: true }
);
